// On a row containing several widgets, the widget divs ([data-position]) do not
// match the visible content: the empty grid area (leading columns) of a
// neighboring widget can cover the content of the previous widget and intercept
// pointer events. The topmost element under the cursor is therefore not reliable
// to identify the widget.
//
// Resolution: within the stack of elements under the cursor
// (document.elementsFromPoint, from topmost to bottommost), favor the first
// element belonging to a widget's actual content — i.e. a descendant of an
// element div [data-item-path] itself contained in a widget div [data-position].
// Empty containers (grid, frame) of neighboring widgets are thus ignored in
// favor of the actually visible content. When no actual content is found, fall
// back to the first widget div of the stack.

export const resolveWidgetDivFromStack = (stack = []) => {
  for (const el of stack) {
    if (!el || typeof el.closest !== 'function') continue;
    const widgetDiv = el.closest('[data-position]');
    if (widgetDiv && el.closest('[data-item-path]')) return widgetDiv;
  }

  for (const el of stack) {
    if (!el || typeof el.closest !== 'function') continue;
    const widgetDiv = el.closest('[data-position]');
    if (widgetDiv) return widgetDiv;
  }

  return null;
};

// Resolves the widget div under a pointer event (hover/click) in the previewer.
export const resolveWidgetDivFromEvent = (event) =>
  resolveWidgetDivFromStack(window.document.elementsFromPoint(event.clientX, event.clientY));
